/**
 * EPL Admin - Placeholder Pages
 * Vistas placeholder para secciones pendientes de implementación
 */

import React from 'react';
import { Brain, FileText, Settings, Shield } from 'lucide-react';

export const AdminAIAnalytics = () => (
  <div className="p-6">
    <div className="max-w-2xl mx-auto mt-20 text-center">
      <div className="w-20 h-20 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <Brain className="w-10 h-10 text-indigo-600" />
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">IA Analytics</h2>
      <p className="text-gray-600 mb-6">
        Panel de análisis avanzado de OpenAI: uso de tokens, costos, tiempos de respuesta y calidad de feedback.
      </p>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-800">
          Próximamente: Gráficos de consumo, análisis de prompts y optimización de costos
        </p>
      </div>
    </div>
  </div>
);

export const AdminReports = () => (
  <div className="p-6">
    <div className="max-w-2xl mx-auto mt-20 text-center">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <FileText className="w-10 h-10 text-green-600" />
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Reportes</h2>
      <p className="text-gray-600 mb-6">
        Genera reportes personalizados de actividad, rendimiento académico y uso del sistema.
      </p>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-800">
          Próximamente: Exportación PDF, Excel, integración con Google Sheets
        </p>
      </div>
    </div>
  </div>
);

export const AdminSettings = () => (
  <div className="p-6">
    <div className="max-w-2xl mx-auto mt-20 text-center">
      <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <Settings className="w-10 h-10 text-orange-600" />
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Configuración</h2>
      <p className="text-gray-600 mb-6">
        Configuración global del sistema: OpenAI, permisos, notificaciones y personalización.
      </p>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-800">
          Próximamente: Gestión de API keys, roles personalizados y configuración de sistemas EPL
        </p>
      </div>
    </div>
  </div>
);

export const AdminAudit = () => (
  <div className="p-6">
    <div className="max-w-2xl mx-auto mt-20 text-center">
      <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <Shield className="w-10 h-10 text-purple-600" />
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Auditoría</h2>
      <p className="text-gray-600 mb-6">
        Registro completo de todas las acciones realizadas en el sistema para seguridad y trazabilidad.
      </p>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-800">
          Próximamente: Logs de sistema, historial de cambios y alertas de seguridad
        </p>
      </div>
    </div>
  </div>
);
